<template>
<div class="page page_dingzhi page_dingzhiDetail">
	<!-- 商家来过 -->
	<div class="tradesman">
		<div class="title">商家来过</div>
		<!-- 商家列表 -->
		<div class="" v-if="info && info.tralook.length != 0">
			<van-swipe :loop="false" v-for="(tralook,index) in info.tralookArr" :key="index">
				<van-swipe-item>
					<ul class="arts clearfix">
						<li class="art f-l" v-for="tradesman in tralook" :key="tradesman.tra_id" @click="toTradsShop(tradesman)">
							<img :src="tradesman.thumb ? ( $publicData.withHttpStart(tradesman.thumb) ? tradesman.thumb : imageUrl+tradesman.thumb) : $publicData.defaultTouxiang" alt="" class="tu">
						</li>
					</ul>
				</van-swipe-item>
			</van-swipe>
		</div>
	</div>
	<!-- 报名商家 -->
	<div class="tradesman">
		<div class="title">报名商家</div>
		<ul class="artList" v-if="info && info.trasignup.length != 0">
			<li class="artItem_wrap" v-for="(singnItem,index) in info.trasignup" :key="index">
				<div class="artItem">
					<div class="artItem_l" @click="toTradsShop(singnItem)">
						<img :src="singnItem.thumb ? ( $publicData.withHttpStart(singnItem.thumb) ? singnItem.thumb : imageUrl+singnItem.thumb) : $publicData.defaultTouxiang" alt="" class="thumb">
					</div>
					<div class="artItem_r">
						<div class="name">{{singnItem.nickname}}</div>
						<div class="tags">
							<div class="tag slh_s" v-if="singnItem.auth_company">{{ singnItem.auth_company }}</div>
							<div class="tag slh_s" v-if="singnItem.skill">{{ singnItem.skill }}</div>
						</div>
					</div>
				</div>
				<div class="artItem_b">
					<div class="artItem_action chat" @click="serveClick(singnItem)">聊一聊</div>
					<!-- <div class="artItem_action coor" @click="agreetradFun(singnItem)">确定合作</div> -->
					<div class="artItem_action coor" v-if="singnItem.is_work != 2" @click="agreetradFun(singnItem)">{{ singnItem.is_work == 0 ? '确定合作' : '已确定合作' }}</div>
				</div>
			</li>
		</ul>
	</div>
	<!-- 操作 -->
	<div class="actions" v-if="info && info.status == 0 && info.work_status == 0">
		<!-- work_status 是否找到合作商家 0/1 -->
		<div class="action" @click="usercancelFun">取消定制</div>
	</div>
</div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    // name: "my-index",
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
			token: null,
			id: this.$route.query.id,
			info: null
        };
    },
    created: function () {
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '我的定制'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                    'notCallLogin': 1,
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                    
                } else {
                    this.token = ''
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
        } else {
            // 获取列表
            this.token = this.$store.getters.token
		}
		this.getDetail()
    },
    methods: {
		// 定制详情
        getDetail(){
			var params = {
				id: this.id
			}
			this.$api.dingzhi.comunitydetail(params).then(res=>{
				if(res.code == 200){
					var info = res.result
					// 重组商家来过 8个一组
					var result = []
					if(info.tralook && info.tralook.length != 0){
						for (var i = 0; i < info.tralook.length; i += 8) {
							result.push(info.tralook.slice(i, i + 8))
						}
					}
					info.tralookArr = result
					this.info = info
				}
			})
		},
		// 去店铺中心
		toTradsShop(tradesman){
			if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/art/detail?tradesmanId=' + tradesman.tra_id
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: '/art/detail',
                    query: {
                        tradesmanId: tradesman.tra_id
                    }
                })
            }
		},
		// 取消合作
		usercancelFun(){
			var params = {
				token: this.token,
				id: this.id
			}
			this.$api.dingzhi.usercancel(params).then(res=>{
				if(res.code == 200){
					this.$toast('取消成功')
					this.$router.back()
				}
			})
		},
		// 确认合作
		agreetradFun(singnItem){
			if(singnItem.is_work == 0){
				var params = {
					token: this.token,
					id: this.id,
					tra_uuid: singnItem.tra_uuid
				}
				this.$api.dingzhi.agreetrad(params).then(res=>{
					if(res.code == 200){
						this.$toast('合作成功')
						this.getDetail()
					}
				})
			}else{
				this.$toast('已与您确定合作,无需再次确认')
			}
			
		},
		serveClick(singnItem) {
            var that = this;
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var memberParams = {
                    data: {},
                };
                this.$bridge.callhandler("sdjy://member/memberInfo",memberParams,(data) => {
                    if (data.code == 200) {
                        this.token = data.result.token;
                        var params = {
                            token: this.token,
                            uuid: singnItem.tra_uuid
                        };
                        that.$api.xiaoxi.userInfo(params).then(res => {
                            if (res.code == 200) {
                                var tradesmanInfo = res.result;
                                // console.log('创建了与匠人的通信')
                                // that.$parent.sendMsgToTradesman('与' + that.tradesmanInfo.username + '建立了通信', that.mine.userId, that.tradesmanInfo.im_username);

                                that.toAppTrademanServe(tradesmanInfo,singnItem);
                            }
                        })
                    }
                });             
            } else {
                if (!this.$store.getters.token) {
                    localStorage.setItem('redirect', this.$router.currentRoute.fullPath)
                    this.$router.push({
                        path: '/login',
                    })
                    return
				}
				console.log(singnItem)
                this.$router.push({
                    path: '/tradesman/chat',
                    query:{
                        uuid: singnItem.tra_uuid 
                    }
                })
                // this.$router.push({
                //     path: '/system/develop'
                // })
            }
        },
        toAppTrademanServe(tradesmanInfo,singnItem) {
            var params = {
                data: {
                    toId: tradesmanInfo.im_username,
                    conversationId: tradesmanInfo.im_username,
                    toAvator: singnItem.thumb,
                    toName: singnItem.nickname,
                    toUUID: singnItem.uuid,
                    toPhone: tradesmanInfo.tradesmans.data.phone,
                    trandsmanId: tradesmanInfo.tradesmans.id
                },
            }
            this.$bridge.callhandler("sdjy://public/chat",params,(data) => {

            });
        },
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
	.page .price .payStatus{
		font-size: .24rem;
	}
</style>
